<template>
    <div>
    <!-- <div :class="isTicketDetailShow?'cant-Scroll':''"> -->
        <div class="infinite-loading-containers" v-if="!details">
            <i class="loading-defaults"></i>
        </div>
        <div class="page-back-btn" onclick="window.history.go(-1)">
            <i class="iconfont icon-yuyin"></i>
       	</div>
        <div class="lmy-ticket" v-if="details">
            <div class="lmy-ticket-banner">
                <Swipe class="index-cal" style="height:5rem;" v-if="details.Imgs&&details.Imgs.length>0" :auto="6000">
                    <SwipeItem  v-for="img in details.Imgs" :key="img" :auto="6000">
                        <img :src="img | replaceImgSrc(4)" :alt="img" style="width:100%"/>
                    </SwipeItem>
                </Swipe>
                <Swipe class="index-cal" style="height:4rem;" v-else>
                    <SwipeItem >
                        <img src="../../assets/img/hotelDetailsDf.png" style="width:100%"/>
                    </SwipeItem>
                </Swipe>
            </div>
            <div class="lmy-ticket-content" >
                <div class="ltc-side">
                    <div class="lmy-ticket-title">
                        {{details.ProductName}}
                    </div>
                     <div class="lmy-ticket-address" @click="routeToMap"><i class="iconfont icon-lmy-dingwei"></i>{{details.Addr}}</div>
                    <div class="lmy-ticket-flex">
                        <div class="lmy-ticket-instr" @click="scopeToPosition('notice')">
                            <div class="instr-head">景区须知</div>
                            <p class="instr-text">开放时间 、入园须知</p>
                            <i class="iconfont icon-more"></i>
                        </div>

                        <div class="lmy-ticket-instr" @click="scopeToPosition('info')">
                            <div class="instr-head">景区介绍</div>
                            <p class="instr-text">景区简介、游玩设施</p>
                            <i class="iconfont icon-more"></i>
                        </div>
                    </div>
                </div>
                <div class="infinite-loading-containers" v-if="ShowSKU">
                    <i class="loading-defaults"></i>
                </div>
                <div class="lmy-tickets" v-if="SKUdata&&SKUdata.length>0">
                    <div class="lmy-ticket-list" v-for="(item,index) in SKUdata" :class="item.active?'active':''">
                        <div :class="item.active?'list-item active':'list-item'" @click="openChild(item,index)">
                            {{item.Name}}
                            <i class="xiala" :class="item.active?'active':''"></i>
                        </div>
                        <div class="list-content" v-show="item.active">
                            <div class="order-s-title" style="color: #555;">游玩日期 <span @click="isTicketInfoShow=true" style="float: right;font-size: 0.28rem;color: #2391ff;">预定须知>></span></div>
                            <div class="date-list" v-if="dailyData&&dailyData.length>0">
                                <div :class="item.Stock>0?(mySelectIndex===index?'list-item active':'list-item'):'list-item disabled'" @click="select(item,index)" v-for="(item,index) in list" >
                                    <p>{{item.Date|dateToYMDline|dateWeek}}</p>
                                    <p>{{item.Date|dateMMtDD}}</p>
                                    <p>{{item.Stock>0?('¥'+item.Price):'不可订'}}</p>
                                </div>
                                <div class=" more" @click="moreDates"><i class="iconfont icon-more"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> 
                <div v-else style="text-align: center; font-weight: bold; color: red;line-height: 1rem;">暂无可售门票</div>   
                <div class="ltc-side">
                    <div class="lmy-ticket-info">
                        <div class="info-title" ref='notice' style="text-align: center;color: #ff6600;">景区须知</div>
                        <div v-for="N,index in details.Notice" :key="index" v-if="N">
                            <div class="lmy-ticket-info">
                                <div class="info-title">{{index}}</div>
                                <div class="info-item" v-html="N"></div>
                            </div>
                        </div>

                        <div v-for="R,index in details.Rule" :key="index" v-if="R">
                            <div class="lmy-ticket-info">
                                <div class="info-title">{{index}}</div>
                                <div class="info-item" v-html="R"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="ltc-side">
                    <div class="lmy-ticket-info">
                        <div class="info-title" ref='info' style="text-align: center;color: #ff6600;" >景区介绍</div>
                    </div>
                    <div class="lmy-ticket-info" style='padding-bottom:1.4rem' v-if="details">
                        <div class="lmy-ticket-info" v-if="details.Items&&details.Items.length>0" v-for="item in details.Items">
                            <div class="info-title">{{item.Title}}</div>
                            <div v-for="img in item.Imgs">
                                <img style="margin-bottom: 0.2rem;" :src="img" alt="">
                            </div>
                            <div class="info-item">{{item.Info}}</div>
                        </div>
                        <!-- <div class="info-title">产品详情</div>
                        <div class="lmy-pur-content" v-if="details.Items&&details.Items.length>0">
                            <div class="room-people-toast" style="margin-bottom:0.2rem">查看景点详情</div>
                            <div class="combo-box">
                                <div :class="detailCombo==item.Title?'combo active':'combo'" v-for="item in details.Items" @click="openTicketDetail(item)">
                                    {{item.Title}}
                                </div>
                            </div>
                        </div> -->
                        
                        <div class="info-item" v-html="details.Detail"></div>
                    </div>
                </div>
            </div>
            <div class="footer-book">
                <!-- <div class="room-people-toast"><span>您选择的产品：</span><span class="free-product-name" style="max-width: 4.5rem;">{{Name||'您还未选择产品'}}</span></div> -->
                <div v-if="mySelect.Price" class="price"><span style="color:#f37a28">￥ <span style="font-weight: bold; font-size: 0.32rem;">{{mySelect.Price}}</span></span> /份</div>
                <div v-else>该套餐暂不可订</div>
                <div class="submit-btn" v-if="mySelect.Price" @click="toBook">
                    预订
                </div>
                <div class="submit-btn" v-else style="background-color: #5f5f5e;">
                    预订
                </div>
            </div>
        </div>
        <TicketDetail v-show="isTicketDetailShow" :vdata="vdata" @close="isTicketDetailShow=false"> </TicketDetail>
        <DailyData :dailyData="dailyData" :handleDate="handleDate" @selectday="selectday" v-show="isDailyDataShow"></DailyData>
        <TicketInfo v-show="isTicketInfoShow" :vdata="ticketBookInfo.Desc" @close="isTicketInfoShow=false"> </TicketInfo>
    </div>
</template>
<script>
    const { Swipe, SwipeItem } = require('vue-swipe');//轮播图
    import ticketDetail from './ticketDetail.vue';//景点详情
    import dailyData from './book/dailyData';//价格日历
    import ticketInfo from './ticketInfo.vue'//预订需知

    export default{
        name:'ticket-details',
        components:{
            Swipe,
            SwipeItem,
            TicketDetail:ticketDetail,
            DailyData:dailyData,
            TicketInfo:ticketInfo,
        },
        data(){
            return{
                ProductID:this.$route.query.ProductID||'',
                SupFlag:this.$route.query.SupFlag||'',
                SKUdata:'',
                details:'',
                prices:'',
                ScenicOpenTimes:'',
                TicketsList:'',
                isTicketDetailShow:false,
                vdata:{},
                Name:'',
                activeCombo:'',
                detailCombo:'',
                ticketBookInfo:'',
                mySelect:'',
                mySelectIndex:'',
                handleDate:'',
                dailyData:[],
                isDailyDataShow:false,
                isTicketInfoShow:false,
                list:'',
                ShowSKU:false
            }
        },
        methods:{
            select(item,index){
                if(!item.Stock){
                    this.mySelectIndex=-1;
                    this.mySelect='';
                    return;
                }
                this.mySelect=item;
                this.mySelectIndex=index;
            },
            moreDates(){
                this.isDailyDataShow=true
                if(this.mySelect){
                    this.handleDate = this.mySelect.Date
                }else{
                    this.handleDate = this.dailyData[0].Date
                }
            },
            //选择其它日期的价格
            selectday(day){
                var data = this.dailyData
                data.forEach((item,index)=>{
                    if(item.Date == day){
                        if(index==data.length-1){
                            this.list = data.slice(-5)
                            this.mySelect = this.list[4]
                            this.mySelectIndex = 4
                        }else{
                            this.list = data.slice(index,index+5)
                            this.mySelect = this.list[0]
                            this.mySelectIndex = 0
                        }
                    }
                })
                this.isDailyDataShow=false;
            },
            //打开下级列表
            openChild(item){
                var that=this;
                that.SKUdata.forEach(item=>{
                    item.active =false
                })
                that.handleCombo(item)
                that.$nextTick(function () {
                    that.$set(item,'active',item.active=true);
                });
            },
            scopeToPosition(name) {
                var infoTop=this.$refs['info'];
                var noticeTop=this.$refs['notice'];
                switch(name){
                    case 'info':
                    window.scrollTo(0, infoTop.offsetTop ); 
                    break;
                    case 'notice':
                    window.scrollTo(0,noticeTop.offsetTop ); 
                    break;
                }
                if(typeof name !='string' && this.$refs['info']){
                    var windowSrollTop = document.documentElement.scrollTop ? document.documentElement.scrollTop : document.body.scrollTop;
                    if(windowSrollTop+176>=infoTop.offsetTop){
                        this.activeTag='info';
                    }else{
                        this.activeTag='notice';
                    }

                }

            },
            backToLastPage(){
                window.history.go(-1)
            },
            // 打开地图
            routeToMap(){
                if(!this.details.BDLAT||!this.details.BDLON){
                    this.error({title:'提示',content:'该景点没有位置信息！'});
                    return;
                }
                this.$router.push(
                    { path: '/baiduMap',query:{lng:this.details.BDLON,lat:this.details.BDLAT,m1:'' ,m2:'',HotelName:this.details.ProductName,hotelId:''}});
            },
            openTicketDetail(item){
                this.detailCombo = item.Title
                this.$nextTick(function () {
                    this.vdata=item;
                })
                this.isTicketDetailShow=true;
            },

            handleCombo(item){
                var that = this;
                that.activeCombo = item.ID
                that.Name = item.Name
                that.ticketBookInfo = item
                item.active = true
                this.getTicketDaily()
            },

            //获取门票价格日历 
            getTicketDaily(){
                var that = this
                var params = {
                    SupFlag:that.SupFlag,
                    ProductID: that.ProductID,
                    Start:that.ticketBookInfo.PriseStart,
                    End:that.ticketBookInfo.PriseEnd||that.getDate(30),
                    SKUID:that.ticketBookInfo.ID
                }
                that.postRequest({
                    url: that.Api.getOnlinePrices,
                    params: params
                }).then(res => {
                    that.ShowSKU = false
                    if (res && res.IsSuccess) {
                        var data = res.Result;
                        var arr = []
                        data.forEach((item)=>{
                            item.Date = item.Date.slice(0,10)
                            arr.push(item)
                        })
                        that.dailyData = arr
                        if(arr.length>5){
                            that.list = arr.slice(0,5)
                        }else{
                            that.list = arr
                        }
                        that.select(arr[0],0)

                    } else {
                        this.dailyData = ''
                        that.SKUdata.forEach(item=>{
                            item.active =false
                        })
                        this.error({title: '提示', content: res.Msg || '该套餐暂无可售！'});
                    }

                });
            },

            //获取门票信息
            getTicketDetails(){
                var that = this;
                that.dao.set('ticketDetailId',JSON.stringify(that.ProductID))
                that.dao.set('ticketDetailFlag',JSON.stringify(that.SupFlag))
                var params = {
                    SupFlag: that.SupFlag,
                    ProductID: that.ProductID
                    
                }
                that.postRequest({
                    url: that.Api.getOnlineDetail,
                    params: params
                }).then(res => {
                    if (res && res.IsSuccess) {
                        that.details = res.Result;
                        if(that.details.Imgs&&that.details.Imgs.length>10){
                            that.details.Imgs = that.details.Imgs.splice(0,10)
                        }
                        that.dao.set('ticketDetails',JSON.stringify(that.details))
                        that.getSKUs(params)
                    } else {
                        this.details = ''
                        this.error({title: '提示', content: res.Msg || '数据错误！'});
                    }

                });
            },
            getSKUs(params){
                var that = this;
                that.ShowSKU = true
                that.postRequest({
                url: that.Api.getOnlineSKUs,
                params: params
                }).then(res => {
                if (res && res.IsSuccess) {
                    var data = res.Result
                    var arr =[]
                    data.forEach((item)=>{
                    arr.push(item.SKU)
                    })
                    that.SKUdata = arr
                    that.handleCombo(that.SKUdata[0])
                    that.dao.set('TicketDetailSKUs',JSON.stringify(that.SKUdata))
                } else {
                    that.SKUdata = ''
                    this.error({title: '提示', content: res.Msg || '数据错误！'});
                }

                });


            },

            toBook() {
                var that = this;
                if (!that.ticketBookInfo) {
                    that.error({ title: "提示", content: "您尚未选购套餐" });
                    return;
                }
                this.dao.set("ticketBookInfo",JSON.stringify(this.ticketBookInfo));
                this.dao.set("ticketSelect",JSON.stringify(this.mySelect));
                this.$router.push("/ticketBook");
                // that.isSubmit = true;
                // var param = {
                //     Token: that.ticketBookInfo.Token
                // };
                // that.postRequest({
                //     url: that.Api.getOnlineCheck,
                //     params: param
                //     }).then(res => {
                //     that.isSubmit = false;
                //     if (res.IsSuccess) {
                //         this.dao.set(
                //         "ticketBookInfo",
                //         JSON.stringify(this.ticketBookInfo)
                //         );
                //         this.$router.push("/ticketBook");
                //     } else {
                //         that.error({ title: "提示", content: res.Msg || "不能预订" });
                //     }
                // });
            },

        },
        mounted(){
            this.getTicketDetails();
        }
    }
</script>



















// WEBPACK FOOTER //
// src/components/ticket/details.vue